var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 0 1034 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 488q41 0 77-15.5t62.5-42 42-62.5 15.5-77-15.5-77-42-62.5-62.5-42T512 94q-40 0-76 15.5t-63 42-42.5 62.5-15.5 77q0 41 15.5 77t42.5 62.5 63 42 76 15.5zm0-342q61 0 104 43t43 103q0 61-43 104t-104 43q-60 0-103-43t-43-104q0-60 43-103t103-43zm247 508q-46-45-107.5-70.5T521 558h-10 1-11q-69 0-130.5 25.5T263 654q-12 11-19 27t-7 34v197q0 11 7 18t17 7h496q11 0 18-7t7-17V713q0-17-6-32.5T759 654zm-23 231H288V715q0-8 3-14.5t9-12.5q39-37 91.5-59T503 607q2 0 4.5.5t4.5.5q1 0 3-.5t4-.5q59 0 111.5 22t92.5 59q5 6 8 12.5t3 14.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.8312beec.svg";
export { ForwardRef as ReactComponent };